import { useState, useEffect } from "react";
import useAuthUserApi from "@apis/useAuthUserApi";

/**
 * 管理收件人店舖資料的 Hook
 * 當選取收件人時，自動載入店舖資料
 *
 * @param {Object} options - 設定選項
 * @param {boolean} [options.isSelected=false] - 是否已選取收件人
 * @returns {Object} 店舖資料
 */
const useReceiverClubData = ({ isSelected = false } = {}) => {
	const { getAuthClubApi } = useAuthUserApi();
	const [clubData, setClubData] = useState({});

	useEffect(
		() => {
			if (isSelected) {
				const doAuthClubApi = async () => {
					let resp = await getAuthClubApi();
					if (resp) {
						setClubData(resp);
					}
				};
				doAuthClubApi();
			}
		},
		// eslint-disable-next-line
		[isSelected],
	);

	return clubData;
};

export default useReceiverClubData;
